import React from 'react';
import { connect } from 'react-redux';

import { sortableHandle, SortableElement, SortableContainer } from 'react-sortable-hoc';

import PredicateChain from '../../../../../common/PredicateChain';
import ArrowTooltipCss from '../../../../../common/ArrowTooltipCss';

import {
  getLastRstData,
  isObjectPredicate,
  getFormsSelectValues,
} from '../../../../../utils';

import { ButtonBase } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import DragIcon from '@mui/icons-material/DragIndicator';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import EditIcon from '@mui/icons-material/Edit';
import TrplSelect from '../../../../../common/TrplControls/TrplSelect';

const DragHandle = sortableHandle(({ classes }) => (
  <div style={{}} className={classes.rowDragHandle}>
    <DragIcon className={`drag-handle-icon ${classes.boundValueDragIcon}`} />
  </div>
));

const SortableChains = SortableContainer(
  ({
    data,
    jels,
    classes,
    rstData,
    concept,
    isDuplicate,
    columnIndex,
    addInnerRstCb,
    removeInnerRst,
    setColumnTitle,
    onRemoveRstClick,
    openFrmEditModal,
    light_meta_and_ops,
    onShowPidsFieldChange,
    conceptRestrictionsIds,
    removePidInMultipleChains,
    addNewShowPidToMultipleChains,
  }) => {
    return (
      <div>
        {rstData.map((rstDataObject, rstObjectIndex) => {
          return (
            <SortableChain
              data={data}
              jels={jels}
              classes={classes}
              concept={concept}
              index={rstObjectIndex}
              isDuplicate={isDuplicate}
              key={`${columnIndex}.${rstObjectIndex}`}
              columnIndex={columnIndex}
              rstObjectIndex={rstObjectIndex}
              rstDataObject={rstDataObject}
              addInnerRstCb={addInnerRstCb}
              removeInnerRst={removeInnerRst}
              setColumnTitle={setColumnTitle}
              onRemoveRstClick={onRemoveRstClick}
              openFrmEditModal={openFrmEditModal}
              light_meta_and_ops={light_meta_and_ops}
              onShowPidsFieldChange={onShowPidsFieldChange}
              conceptRestrictionsIds={conceptRestrictionsIds}
              removePidInMultipleChains={removePidInMultipleChains}
              addNewShowPidToMultipleChains={addNewShowPidToMultipleChains}
            />
          );
        })}
      </div>
    );
  }
);


const SortableChain = SortableElement(
  ({
    jels,
    classes,
    concept,
    isDuplicate,
    columnIndex,
    rstDataObject,
    rstObjectIndex,
    openFrmEditModal,
    light_meta_and_ops,
    onShowPidsFieldChange,
    conceptRestrictionsIds,
    removePidInMultipleChains,
    addNewShowPidToMultipleChains,
  }) => {

    const pids = rstDataObject.pids;
    const objEditableFrm = rstDataObject.obj_editable_frm;

    let lastRst, editObjectForms;
    if (pids) {
      lastRst = getLastRstData(pids, concept, light_meta_and_ops.setup_rbox_light);
      if (lastRst && isObjectPredicate(lastRst)) {
        editObjectForms = getFormsSelectValues(jels, lastRst.oid, light_meta_and_ops.setup_rbox_light);
      }
    }

    const rstBelongToConcept = pids && pids.length && conceptRestrictionsIds.includes(pids[0]);

    const hasErrors = isDuplicate || !rstBelongToConcept;
    const errorText = !rstBelongToConcept ? "No restrictions applied" : 'This view already contains same predicate';

    return (
      <div style={{ margin: '3px 0', display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ width: '30px' }}>
          <DragHandle classes={classes} editable />
        </div>
        <div style={{ marginRight: '10px', width: '-webkit-fill-available' }}>
          <PredicateChain
            rstIdIndex={rstObjectIndex}
            rst={pids}
            props={{
              index: rstObjectIndex,
              columnIndex: columnIndex,
            }}
            mode="edit"
            ancestor={concept}
            addInnerRstCb={addNewShowPidToMultipleChains}
            onRemoveRstCb={removePidInMultipleChains}
          />
        </div>

        {editObjectForms ? (
          <div style={{ display: 'flex', marginRight: '50px' }}>
            <TrplSelect
              margin="none"
              complicatedValues
              values={editObjectForms}
              style={{ minWidth: '200px' }}
              placeholder='Select on edit click form'
              firstChilds={
                <React.Fragment>
                  <ButtonBase
                    style={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                    onClick={() => {
                      openFrmEditModal(
                        true,
                        { concept: lastRst.oid, showPidsIndex: rstObjectIndex }
                      );
                    }}
                    className={`${classes.btnGray} ${classes.mb5}`}
                  >
                    Create form <AddIcon className={`btn-gray-icon ${classes.btnGrayIcon}`} />
                  </ButtonBase>
                </React.Fragment>
              }
              value={objEditableFrm}
              onChange={(e) => onShowPidsFieldChange(rstObjectIndex, 'obj_editable_frm', e.target.value, columnIndex)}
            />

            <ButtonBase
              disabled={!Boolean(objEditableFrm)}
              style={{
                opacity: `${!Boolean(objEditableFrm) ? '0.5' : ''}`,
                marginLeft: '5px',
              }}
            >
              <EditIcon
                style={{ display: 'flex', opacity: '1' }}
                className={classes.editFrmIcon}
                onClick={() => {
                  openFrmEditModal(
                    objEditableFrm,
                    { 'concept': lastRst.oid, 'showPidsIndex': rstObjectIndex }
                  );
                }}
              />
            </ButtonBase>
          </div>
        ) : null}

      {hasErrors &&
      <ArrowTooltipCss text={errorText}>
        <ErrorIcon
          style={{
            color: '#DD5900',
            marginLeft: '5px',
          }}
        />
      </ArrowTooltipCss>}
    </div>
  )}
);

export default connect((state) => ({
  light_meta_and_ops: state.meta.light_meta_and_ops,
}))(SortableChains);
